import {ivStoreView, IvStoreView} from "./view/IvStoreViewComponent";

import Components from "./components";
import {IvStoreService} from "./services/IvStoreService";

export default function(parentDir: string) {

    const rootDir = `${parentDir}/iv`;

    return angular.module("tfApp.store.iv", [Components(rootDir)])
                  .component(IvStoreView, ivStoreView(rootDir))
                  .service(IvStoreService.id, IvStoreService)
                  .name;
}
